import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';

export async function PUT(request: NextRequest) {
  try {
    const body = await request.json();
    const { gymId, status } = body;
    
    console.log(`🏢 Updating gym ${gymId} status to ${status}`);
    
    if (!gymId || !status) {
      return NextResponse.json(
        { error: 'Gym ID and status are required' },
        { status: 400 }
      );
    }
    
    if (!['approved', 'rejected'].includes(status)) {
      return NextResponse.json(
        { error: 'Status must be approved or rejected' },
        { status: 400 }
      );
    }
    
    const { pool } = await import('@/lib/db');
    await pool.execute(
      'UPDATE gyms SET status = ?, updated_at = NOW() WHERE id = ?',
      [status, gymId]
    );
    
    console.log(`✅ Gym ${gymId} ${status} successfully`);
    
    return NextResponse.json({
      success: true,
      message: `Gym ${status} successfully`
    });
  } catch (error) {
    console.error('❌ Error updating gym:', error);
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    return NextResponse.json(
      { error: 'Failed to update gym: ' + errorMessage },
      { status: 500 }
    );
  }
}
